import { useMediaQuery } from "@mui/material";
import {
  BlockWrapper,
  defineBlock,
  smartProps,
  useEditor,
  useInspectorControl,
} from "@smartfire/js-block-engine";
import React from "react";
import style from "./block.module.scss";

const Inspector = React.lazy(() => import("./Inspector.js"));

const Slide = ({ image, imageMobile, link, isInternal, blank }) => {
  useInspectorControl(Inspector);
  const { isEditing } = useEditor();
  const isMobile = useMediaQuery(`(max-width: ${style.mobileBreakpoint})`);

  if (isEditing) {
    return (
      <BlockWrapper.Div className={style.admin}>
        {image?.url && (
          <img
            className={style.image}
            src={image.url}
            alt={image.title}
            loading="lazy"
          />
        )}
      </BlockWrapper.Div>
    );
  }

  return (
    <BlockWrapper.A
      className={style.block}
      href={link || undefined}
      target={blank ? "_blank" : undefined}
      rel={!isInternal ? "noopener noreferrer" : undefined}
    >
      {image?.url && (
        <img
          className={style.image}
          src={isMobile && imageMobile?.url ? imageMobile.url : image.url}
          alt={isMobile && imageMobile?.url ? imageMobile.title : image.title}
          loading="lazy"
        />
      )}
    </BlockWrapper.A>
  );
};

export default defineBlock({
  Block: Slide,
  smartProps: {
    image: smartProps.image,
    imageMobile: smartProps.image,
    link: smartProps.string.withDefault(""),
    isInternal: smartProps.bool.withDefault(false),
    blank: smartProps.bool.withDefault(false),
  },
  setup: {
    title: "Home Hero - Slide image",
    parent: ["smartfire/home-hero-2"],
  },
});
